<template>
  <div
    :class="cssClass.parent"
    ref="tooltip"
    @click.stop
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
  >
    <div v-if="$slots.title" :class="cssClass.header">
      <p :class="cssClass.title"><slot name="title"></slot></p>
    </div>
    <div v-if="$slots.default" :class="cssClass.content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    margin: {
      type: Number,
      required: false,
      default: 20
    },
    position: {
      type: Object,
      required: true
    },
    size: {
      type: Object,
      required: false
    },
    timeType: {
      type: String,
      required: false
    },
    variant: {
      type: [Number, String],
      required: false
    },
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    cssClass() {
      return {
        parent: {
          'c-graph-tooltip': true,
          ['c-graph-tooltip--' + this.variant]: this.variant,
          'is-visible': this.isVisible
        },
        content: {
          'c-graph-tooltip__content': true,
          ['c-graph-tooltip--' + this.variant + '__content']: this.variant
        },
        header: {
          'c-graph-tooltip__header': true,
          ['c-graph-tooltip--' + this.variant + '__header']: this.variant
        },
        title: {
          'c-graph-tooltip__title': true,
          ['c-graph-tooltip__title--' + this.timeType]: this.timeType,
          ['c-graph-tooltip--' + this.variant + '__title']: this.variant
        }
      };
    }
  },
  watch: {
    position: {
      handler() {
        if (!this.isVisible) {
          return;
        }
        this.setPosition();
      },
      deep: true
    },
    isVisible(value) {
      if (!this.isVisible) {
        return;
      }
      this.$refs.tooltip.style.left = 'auto';
      this.$refs.tooltip.style.top = 'auto';

      this.$nextTick(() => {
        let rect = this.$refs.tooltip.getBoundingClientRect();
        this.height = Math.ceil(rect.height);
        this.width = Math.ceil(rect.width);
        this.setPosition();
      });
    }
  },
  methods: {
    mouseenter(e) {
      this.$emit('mouseenter', e);
    },
    mouseleave(e) {
      this.$emit('mouseleave', e);
    },
    setPosition() {
      let left = this.position.x + this.margin;
      let top = this.position.y + this.margin - this.height / 2;
      if (
        this.position.x >
        Math.ceil((this.size.canvasW + this.size.axisYW.left) / 2)
      ) {
        left -= this.width + this.margin * 2;
      }
      this.$refs.tooltip.style.left = Math.round(left) + 'px';
      this.$refs.tooltip.style.top = Math.round(top) + 'px';
    }
  }
};
</script>
